import SmartImage from './SmartImage';
import type { HomePageItem } from '@/models/HomePage';
import Link from 'next/link';

function BannerUnderCard({ item }: { item: HomePageItem }) {
  return (
    <div className="flex md:flex-row flex-col items-center gap-2">
      {item.imageUrl ? (
        <SmartImage
          src={item.imageUrl}
          alt={item.title || ''}
          width={88}
          height={90}
          imageType="sub-banner"
          quality={60}
          loading="lazy"
          sizes="88px"
          className="md:w-[88px] md:h-[89.6px] w-[45px] h-[48px]"
        />
      ) : null}
      <div>
        {item.title ? (
          <div className="font-poppins font-bold md:text-[16px] text-[11px] md:leading-[21px] tracking-[0] align-middle md:text-start text-center text-[#2B3280]">
            {item.title}
          </div>
        ) : null}
        {item.description ? (
          <div className="hidden md:block font-poppins font-medium text-[13px] leading-[20px] tracking-[-0.005em] [font-variant-numeric:lining-nums_proportional-nums]">
            {item.description}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export function BannerUnderContentStrip({ items }: { items: HomePageItem[] }) {
  if (!items.length) return null;

  return (
    <div className="flex flex-row gap:1 md:gap-4 max-w-7xl w-full mx-auto my-4 md:my-8 px-4 md:px-0">
      {items.map((item, index) => {
        const key = `${item.title || 'banner-under'}-${index}`;
        if (item.url) {
          return (
            <Link key={key} href={item.url} prefetch={false} className="grow-1 basis-1/3">
              <BannerUnderCard item={item} />
            </Link>
          );
        }
        return (
          <div key={key} className="grow-1 basis-1/3">
            <BannerUnderCard item={item} />
          </div>
        );
      })}
    </div>
  );
}
